export function designRirekisho002DocPaperStyle(
  isSample: boolean
): Record<string, string | number> {
  return {
    fontFamily:
      "'Noto Sans JP', 'Noto Sans JP Regular', 'Noto Sans Japanese', MyFontFamily, 'Segoe UI Emoji', 'Segoe UI Symbol', 'Apple Color Emoji', 'Noto Color Emoji', 'Noto Emoji', sans-serif",
    fontWeight: 400,
    background: '#fff',
    color: '#000',
    fontSize: '15px',
    width: '794px',
    height: '1123px',
    maxHeight: '1123px',
    padding: '0',
    margin: isSample ? '0 auto' : '2rem 0 0 20px',
    boxSizing: 'border-box',
    wordWrap: 'break-word',
    overflow: 'hidden',
    minHeight: 'auto',
    border: 'none'
  }
}

export function designRirekisho002DocPaperPage2Style(
  isSample: boolean
): Record<string, string | number> {
  return {
    ...designRirekisho002DocPaperStyle(isSample),
    pageBreakBefore: 'always'
  }
}

export function designRirekisho002SidebarStyle(
  isSample: boolean
): Record<string, string> {
  return {
    width: '220px',
    paddingRight: '20px',
    paddingLeft: isSample ? '0' : '20px',
    borderRight: '2px solid #404040',
    marginRight: '20px',
    minHeight: '820px',
    overflow: 'hidden'
  }
}
